export const setChatAuthToken = (token, id) => {
  localStorage.setItem("chatToken", token);
  localStorage.setItem("userId", id);
};

export const getChatAuthToken = () => {
  return {
    token: localStorage.getItem("chatToken"),
    userId: localStorage.getItem("userId"),
  };
};
